import { useAuth0 } from "@auth0/auth0-react"
import { useCallback, useEffect, useState } from "react"

export const useGetDeviceConfigById = (deviceID) => {
	const [isLoading, setIsLoading] = useState(false)
	const [isError, setIsError] = useState(false)
	const [data, setData] = useState({
		enableDebug: false,
		otp: false,
		ftp_enabled: null
	})

	const { getAccessTokenSilently } = useAuth0()

	const getDeviceConfigById = useCallback(async () => {
		setIsLoading(true)
		fetch(
			new Request(process.env.REACT_APP_SESSION_ADDR + "/api/v2/device/" + deviceID + "/config", {
				method: "GET",
				headers: new Headers({
					"authorization": "Bearer " + (await getAccessTokenSilently()),
					"Content-Type": "application/json"
				})
			})
		)
			.then((response) => {
				if (response.ok) {
					console.log("Get Device config by Id successfully!")
					return response.json()
				} else if (response.statusText === "Unauthorized") {
					throw new Error("Unauthorized")
				} else {
					throw new Error("Something went wrong")
				}
			})
			.then((result) => {
				setIsError(false)
				setData(result ? result : null)
			})
			.catch((err) => {
				setIsError(true)
				console.log(err)
			})
			.finally(() => setIsLoading(false))
	}, [getAccessTokenSilently])

	useEffect(() => {
		return () => {
			setIsError(false)
			setIsLoading(false)
		}
	}, [])

	return { isLoading, data, setData, isError, getDeviceConfigById }
}
